import { render, staticRenderFns } from "./CountCorrectHead.vue?vue&type=template&id=63c13d40"
import script from "./CountCorrectHead.vue?vue&type=script&lang=js"
export * from "./CountCorrectHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports